import React from 'react';

export const ProjectsDashboardContext = React.createContext({});

export const useProjectsDashboardContext = () =>
  React.useContext(ProjectsDashboardContext);
